export const UserType = {
  GET_USER: 'GET_USER',
  SET_USER_REDUCER: 'SET_USER_REDUCER'
}
